import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import FileUploadStore from 'stores/files/FileUploadStore';
import FileUploadScorecardActions from 'actions/scorecards/FileUploadScorecardActions';
import FileUploadScorecardStore from 'stores/scorecards/FileUploadScorecardStore';
import FileUploadCallCardActions from 'actions/FileUploadCallCardActions';
import AuthStore from 'stores/AuthStore';
import CardReasonStore from 'stores/CardReasonStore';
import FileUploadCallCardStore from 'stores/files/FileUploadCallCardStore';
import ScorecardQuestionnaireStore from 'stores/scorecards/ScorecardQuestionnaireStore';
import ScorecardSchemeLabelActions from 'actions/scorecards/ScorecardSchemeLabelActions';
import ScorecardSchemeLabelStore from 'stores/scorecards/ScorecardSchemeLabelStore';
import LiveCoaching from 'components/pure/scorecards/live-coaching/LiveCoaching';
import UserActions from 'actions/UserActions';
import UserStore from 'stores/UserStore';
import LiveCoachingCall from 'records/LiveCoachingCall';
import LiveCoachingActions from 'actions/scorecards/LiveCoachingActions';
import LiveCoachingStore from 'stores/scorecards/LiveCoachingStore';
import moment from 'moment';
import SkillActions from 'actions/SkillActions';
import CoachingPlanActions from 'actions/coaching/CoachingPlanActions';
import CoachingPlanStore from 'stores/coaching/CoachingPlanStore';
import ScorecardQuestionnaireActions from 'actions/scorecards/ScorecardQuestionnaireActions';
import CoachingReviewTypeStore, {typesAndCategories} from 'stores/coaching/CoachingReviewTypeStore';
import CardReasonActions from 'actions/CardReasonActions';
import {ensureReviewMetadata} from 'components/StatsPage2.utils';

@connectToStores
export default class LiveCoachingContainer extends React.PureComponent {
  componentDidMount() {
    const {callId, callerId, planId} = this.props.location.state;
    FileUploadScorecardActions.fetchScorecards(callId);
    CardReasonActions.fetchReasonSchemesForCall.defer(callId);
    ScorecardSchemeLabelActions.labels();
    FileUploadCallCardActions.toggleScorecardResults(false);
    ensureReviewMetadata();

    // get all the users on the account for rep search
    UserActions.fetchAll().then(users => {
      const rep = users.find(u => u.id === callerId);

      SkillActions.fetchAllByTeam({team_id: rep.team_id});
    });

    // some accounts have custom directions (inbound, outbound, etc)
    LiveCoachingActions.directions(callerId);

    // we start an adhoc plan for this primarily so we record coaching time,
    // so let's grab that too so we can finish it out when they're done
    CoachingPlanActions.retrieve(planId, {includeReviews: true});

    // Clear any existing scorecard sessions
    ScorecardQuestionnaireActions.clearState();

    // Get all the plans for our rep, so we know which skills
    // not to suggest
    CoachingPlanActions.fetchAll({
      recipientId: callerId,
      includeReviews: true,
    });
  }

  static getStores() {
    return [
      AuthStore,
      ScorecardQuestionnaireStore,
      FileUploadCallCardStore,
      FileUploadStore,
      ScorecardSchemeLabelStore,
      FileUploadScorecardStore,
      UserStore,
      LiveCoachingStore,
      CoachingPlanStore,
      CoachingReviewTypeStore,
    ];
  }

  static getPropsFromStores(props) {
    const {callId} = props.location.state;
    const questionnaireState = ScorecardQuestionnaireStore.getState();
    const reasonState = CardReasonStore.getState();
    const schemeLabelState = ScorecardSchemeLabelStore.getState();
    const scorecards = FileUploadScorecardStore.getState().getIn(['scorecards', callId]);
    const {areScorecardResultsToggled} = FileUploadCallCardStore.getState();
    const {users} = UserStore.getState();
    const {directions, hasSubmittedScorecards} = LiveCoachingStore.getState();

    const {planMap} = CoachingPlanStore.getState();
    const [, types] = typesAndCategories(CoachingReviewTypeStore);

    return {
      scorecards,
      sessionUser: AuthStore.getState().user,
      answers: questionnaireState.getIn(['answers', callId]),
      reasons: questionnaireState.getIn(['reasons', callId]),
      comments: questionnaireState.getIn(['comments', callId]),
      taggedUsers: questionnaireState.getIn(['taggedUsers', callId]),
      reasonSchemes: reasonState.get('cardReasons'),
      schemeLabels: schemeLabelState.labels,
      isSaving: questionnaireState.get('isSaving'),
      isEditing: questionnaireState.get('isEditing'),
      areScorecardResultsToggled,
      users,
      directions,
      planMap,
      hasSubmittedScorecards,
      types,
    };
  }

  render() {
    const {callId, callerId, planId, back, nonAdHoc, onSubmit, reviewId} =
      this.props.location.state;

    const {planMap} = this.props;

    const model = new LiveCoachingCall({
      id: callId,
      callerId,
      dateTime: moment(),
    });

    const plan = planMap.get(planId);
    if (!plan) return null;

    const review = reviewId ? plan.reviews.find(r => r.id === reviewId) : plan.reviews.get(0);

    return (
      <LiveCoaching
        {...this.props}
        nonAdHoc={nonAdHoc}
        model={model}
        modelId={callId}
        plan={plan}
        review={review}
        back={back}
        onSubmit={onSubmit}
      />
    );
  }
}
